export const testimonialsArray = [
  {
    name: 'James H.',
    date: 'March 1, 2025',
    review:
      'Ascari Building Contractors did an incredible job on our home extension. The team was professional, efficient, and delivered high-quality workmanship. Highly recommend!',
  },
  {
    name: 'Sarah W.',
    date: 'February 20, 2025',
    review:
      'We hired Ascari for a full home renovation, and the results exceeded our expectations. Every detail was handled with precision and care. Fantastic work!',
  },
  {
    name: 'David M.',
    date: 'January 10, 2025',
    review:
      'Reliable, skilled, and great to work with! Ascari Building Contractors transformed our outdated kitchen into a modern space we love. Will definitely use them again.',
  },
];
